import { render } from "./NetAverage.vue?vue&type=template&id=ec73b642"
import script from "./NetAverage.vue?vue&type=script&lang=js"
export * from "./NetAverage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/card/NetAverage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec73b642"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec73b642', __exports__)) {
    api.reload('ec73b642', __exports__)
  }
  
  module.hot.accept("./NetAverage.vue?vue&type=template&id=ec73b642", () => {
    api.rerender('ec73b642', render)
  })

}


export default __exports__